import countries from "i18n-iso-countries";
import countriesLocaleEN from "i18n-iso-countries/langs/en.json";

countries.registerLocale(countriesLocaleEN);

export default class Country {

    static all() {
        return Object.keys(
            countries.getAlpha3Codes()
        );
    }

    static compare(a: Country | string, b: Country | string) {
        const aCountry = a instanceof Country ? a : Country.fromCode(a);
        const bCountry = b instanceof Country ? b : Country.fromCode(b);
        return aCountry.compareTo(bCountry);
    }

    static fromCode(code: string) {
        return new this(code);
    }

    get alpha2Code() {
        return countries.alpha3ToAlpha2(this.alpha3Code);
    }

    get name() {
        return countries.getName(this.alpha3Code, "en");
    }

    constructor(
        readonly alpha3Code: string,
    ) {}

    compareTo(country: Country) {
        return this.name.localeCompare(country.name);
    }

}
